module.exports = __webpack_public_path__ + "img/gestion_illu.ead1567c.png";